import { ReactNode } from "react";
import { useLocation } from "react-router-dom";
import Card from "./card";

interface HeaderInfo {
  title: string;
  subtitle: string;
}

interface InfoLayoutProps {
  children: ReactNode;
  Provider?: React.ComponentType<{ children: ReactNode }>;
  Sidebar: React.ComponentType;
  headerMap: Record<string, HeaderInfo>;
  getHeaderKey: (location: any) => string;
}

const InfoLayout = ({
  children,
  Provider,
  Sidebar,
  headerMap,
  getHeaderKey,
}: InfoLayoutProps) => {
  const location = useLocation();
  const headerKey = getHeaderKey(location);
  const header = headerMap[headerKey] || headerMap["/"];

  const Content = (
    <div className="mt-5 flex font-dm">
      <Sidebar />

      <div className="relative mt-4 flex flex-1 flex-col overflow-hidden sm:mt-0 ">
        <main className="flex-1 overflow-y-auto ">
          <div className="h-full w-full max-w-none">
            <Card extra="px-6 py-8 sm:px-8 ml-5 h-full ">
              {/* Header */}
              <div className="mb-8">
                <h1 className="mb-2 text-2xl font-semibold text-gray-900 dark:text-gray-100">
                  {header.title}
                </h1>
                <p className="text-sm text-gray-600 dark:text-gray-400">
                  {header.subtitle}
                </p>
              </div>
              {/* Content */}
              {children}
            </Card>
          </div>
        </main>
      </div>
    </div>
  );

  return Provider ? <Provider>{Content}</Provider> : Content;
};

export default InfoLayout;
